
import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewModel from '@/models/ViewModel'
import MediaPropertyForm from './MediaPropertyForm.vue'

@Component({
  components: {
    MediaPropertyForm,
  },
})
export default class MediaPropertyEdit extends ViewModel {
  @Prop()
  public id!: string

  private get title() {
    return this.id ? 'Edit Media Property' : 'Create Media Property'
  }
}
